import axios from 'axios';
import { apiPaths } from 'constants/path';
import { tokenHeader } from 'functions/apiFunctions';
import { DiagnosisUpdateReqeustType, IDDiagnosisApi, IDDiagnosisListApi, UpdateNoShowInfoRqData } from 'models/DCK/DCKApiTypes';
import { AssignCounselorRqData } from 'models/MindUp/MindUpTypes';

class DiagnosisApi {
    async getDiagnosisList(url: string, token: string): Promise<IDDiagnosisListApi> {
        try {
            const response = await axios.get(apiPaths.getDiagnosisList + url, { headers: tokenHeader(token) });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async findByHospitalId(url: string, token: string): Promise<IDDiagnosisListApi> {
        try {
            const response = await axios.get(apiPaths.findByHospitalId + url, { headers: tokenHeader(token) });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async getListByStatus(rqData: { status: number[] }, token: string): Promise<IDDiagnosisListApi> {
        try {
            const response = await axios.post(apiPaths.getListByStatus, rqData, { headers: tokenHeader(token) });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async updateAssignCounselor(rqData: AssignCounselorRqData, token: string): Promise<IDDiagnosisListApi> {
        try {
            const response = await axios.put(apiPaths.updateAssignCounselor, rqData, {
                headers: tokenHeader(token),
            });

            return response.data;
        } catch (error) {
            throw error;
        }
    }
    async updateNoShowInfo(rqData: UpdateNoShowInfoRqData, token: string): Promise<IDDiagnosisListApi> {
        try {
            const response = await axios.put(apiPaths.updateNoShowInfo, rqData, {
                headers: tokenHeader(token),
            });

            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async getDiagnosis(url: string, token: string): Promise<IDDiagnosisApi> {
        try {
            const response = await axios.get(apiPaths.getDiagnosis + url, {
                headers: tokenHeader(token),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
    async changeDiagnosisStatus(rqData: { _id: string; status: number }, token: string): Promise<IDDiagnosisApi> {
        try {
            const response = await axios.put(apiPaths.changeDiagnosisStatus, rqData, {
                headers: tokenHeader(token),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async updateDiagnosisInfo(rqData: DiagnosisUpdateReqeustType, token: string): Promise<IDDiagnosisApi> {
        try {
            const response = await axios.put(apiPaths.updateDiagnosisInfo, rqData, {
                headers: tokenHeader(token),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async clearDiagnosis(url: string, token: string): Promise<IDDiagnosisApi> {
        try {
            const response = await axios.get(apiPaths.clearDiagnosis + url, {
                headers: tokenHeader(token),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export const DCKDiagnosisApi = new DiagnosisApi();
